export default "__VITE_PUBLIC_ASSET__c84d1eda__"